import { Switch } from '@mui/material';
import React from 'react';

export const AppSwitch = ({
  isChecked = false,
  onSwitchChange = (value) => {},
}: {
  isChecked: boolean;
  onSwitchChange?: (props: any) => void;
}) => {
  return (
    <div>
      <div
        onClick={() => onSwitchChange(!isChecked)}
        className={`w-[40px] h-[22px] rounded-full p-[1px] grid flex-col cursor-pointer ${
          isChecked ? 'justify-items-end bg-[#3862fb]' : 'GREY_500-BG'
        }`}>
        <div className="bg-white w-[20px] h-[20px] rounded-full" />
      </div>
    </div>
  );
};
